import { startTransition, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export const useRedirect = () => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const { lang } = useParams();

  useEffect(() => {
    if (pathname.slice(-1) !== "/") {
      if (search) {
        return navigate(`${pathname}/${search}`, { replace: true });
      } else {
        return navigate(`${pathname}/`, { replace: true });
      }
    }
  }, [lang, pathname]);
};
